import { API_BASE_URL } from '../common/ApiClient';

export { useGetClassifierMappingQuery } from './query/useGetClassifierMappingQuery';
export { useClassifierMappingMutation } from './query/useClassifierMappingMutation';
export * from './query/useListClassifierMappingQuery';
export {
  useLockMutation,
  useObjectLockQuery,
} from '../lock/query/useLockQuery';
export { useMutateClassifierMappingUpload } from './query/useMutateClassifierMappingUpload';
export { CategoryMappingDetailTable } from './components/CategoryMappingDetailTable';
export { ClassifierMappingAutoComplete } from './components/ClassifierMappingAutoComplete';
export * from './components/useCategoryTypeOptions';
export * from './types';
export * from './utils';

export const ClassifierMappingExcelUrl =
  API_BASE_URL + '/classifier-mappings{/id}/excel';

export const ClassifierMappingDetailsUrl =
  '/data-dictionary/classifier-mappings{/id}';
